import { writable } from 'svelte/store'

export const section = writable('tour') // tour